import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const TestsFrequency: React.FC = () => {
  const { locale } = useRouter();

  const GRAPH_05_TESTS_IN_A_HIRING_PROCESS_FREQUENCY = [
    { label: 'Screening HR', value: 98 },
    {
      label: locale === 'es' ? 'Prueba técnica' : 'Technical Assessment',
      value: 71
    },
    {
      label: locale === 'es' ? 'Entrevista técnica' : 'Technical Interview',
      value: 59
    },
    {
      label:
        locale === 'es'
          ? 'Entrevista con Management'
          : 'Interview with Management',
      value: 63
    },
    { label: locale === 'es' ? 'Fit Cultural' : 'Cultural Fit', value: 47 },
    {
      label: locale === 'es' ? 'Entrevista con el equipo' : 'Team Interview',
      value: 37
    },
    {
      label: locale === 'es' ? 'Test de Personalidad' : 'Personality Test',
      value: 8
    },
    {
      label: locale === 'es' ? 'Prueba de idiomas' : 'Language Test',
      value: 6
    },
    {
      label:
        locale === 'es' ? 'Comprobación de referencias' : 'Reference Check',
      value: 4
    },
    {
      label: 'Bar Raiser',
      value: 4
    },
    {
      label:
        locale === 'es' ? 'Entrevista con cliente' : 'Interview with Client',
      value: 2
    }
  ];

  const sortedData = GRAPH_05_TESTS_IN_A_HIRING_PROCESS_FREQUENCY.sort(
    (a, b) => b.value - a.value
  );

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer width="99%" height={560}>
          <BarChart data={sortedData} layout="vertical" margin={{ right: 30 }}>
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 10 }}
              hide={true}
            />
            <YAxis
              type="category"
              dataKey="label"
              tickLine={false}
              width={180}
            />
            <Bar
              dataKey="value"
              isAnimationActive={false}
              fill="#8DC3D7"
              barSize={74}
            >
              <LabelList
                dataKey="value"
                formatter={(value: number) => [value + '%']}
                position="right"
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default TestsFrequency;
